import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-12 px-4 bg-guarantee border-y border-accent-gold/20" ref={ref} data-id="element-71">
      <div className="max-w-[700px] mx-auto text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-5" data-id="element-73">
          <ShieldCheckIcon className="w-20 h-20 text-accent-gold animate-pulse-glow" data-id="element-74" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-75">
          Garantía por Inconvenientes — 7 Días
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-white text-lg leading-[1.7] mb-5" data-id="element-76">
          Si en los primeros 7 días tenés algún inconveniente con el material,
          te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios
          complicados. Sin burocracia. Tu inversión está completamente
          protegida.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="inline-block bg-accent-teal text-white font-bold px-6 py-2 rounded-full" data-id="element-77">
          ✅ Riesgo Cero — Tu dinero está protegido
        </motion.div>
      </div>
    </section>;
}